import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import ModeToggle from '@/components/authForm/ModeToggle';
import BackButton from '@/components/dtcPartnerships/BackButton';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAnalytics } from '@/hooks/analytics';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';
import genericMessages from '@/messages/messages';
import { User } from '@/store/user/types';

import { SignupScreenProps } from '../shared/types';
import messages from './messages';
import {
	AccountContentWrapper,
	BackButtonContainer,
	CtaText,
	DTCLoginForm,
	FaqLink,
	FaqText,
	LockIcon,
	MailIcon,
	ProfileIcon,
	TermsText,
} from './styles';

const Account = ({ onScreenChange, partnerDetails, onSuccess }: SignupScreenProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();
	const { faqLink, disableSocialSignup } = partnerDetails.pageInfo;
	const termsMessage = partnerDetails.requires_data_sharing
		? genericMessages.loginTermsDataSharing
		: genericMessages.signupTerms;

	useComponentDidMount(() => {
		logEvent({ eventName: 'D2C Redemption: Account : Landed' });
	});

	function onAuthSuccess(user: User): void {
		onSuccess(user);
	}

	const DtcLoginFormInputIcons = {
		name: ProfileIcon,
		email: MailIcon,
		password: LockIcon,
	};

	const isChegg = partnerDetails.slug === 'chegg';

	return (
		<AccountContentWrapper centerAlign>
			<BackButtonContainer>
				<BackButton onScreenChange={onScreenChange} />
				<ModeToggle isB2B />
			</BackButtonContainer>
			{authPrompt === 'login' && <CtaText>{formatMessage(genericMessages.loginCalmTitle)}</CtaText>}
			{authPrompt === 'signup' && (
				<>
					<CtaText>{formatMessage(genericMessages.signupTitle2)}</CtaText>
				</>
			)}
			<DTCLoginForm
				className="b2bLoginForm"
				onAuthSuccess={onAuthSuccess}
				disableSocialSignup={disableSocialSignup}
				disableFormToggle
				inputIcons={DtcLoginFormInputIcons}
				showInputIcons
				isB2B
			/>
			{isChegg && (
				<FaqText>
					{authPrompt === 'login' && (
						<>
							{formatMessage(messages.loginFaqCopy, {
								faqtext: (...chunks: ReactNode[]) => (
									<FaqLink href={faqLink} target="_blank">
										{chunks}
									</FaqLink>
								),
							})}{' '}
						</>
					)}
					{(authPrompt === 'login' || isChegg) && (
						<>
							{formatMessage(messages.faq, {
								faqtext: (...chunks: ReactNode[]) => (
									<FaqLink href={faqLink} target="_blank">
										{chunks}
									</FaqLink>
								),
							})}
						</>
					)}
				</FaqText>
			)}
			<TermsText>
				{formatMessage(termsMessage, {
					terms: (
						<a href="/terms" target="_blank">
							{formatMessage(genericMessages.terms)}
						</a>
					),
					privacypolicylink: (...chunks) => (
						<a href="/privacy" target="_blank">
							{chunks}
						</a>
					),
				})}
			</TermsText>
		</AccountContentWrapper>
	);
};

export default Account;
